import type { components } from "@/api/schema";

import { formatPeriod } from "./format-period";

type Promotion = components["schemas"]["Promotion"];

const HEADER = [
  "Name",
  "Campaign",
  "Marketplace",
  "Seller",
  "Period",
  "Status",
  "Used",
  "Total",
  "Note",
] as const;

function escapeCsv(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = String(value);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/** Serialise the visible promotion rows to CSV (header + rows). */
export function promotionsToCsv(items: Promotion[]): string {
  const rows = items.map((p) =>
    [
      p.name,
      p.campaign_name ?? "",
      p.marketplace,
      p.seller_id,
      formatPeriod(p.start_at, p.end_at),
      p.status,
      p.quota_used,
      p.quota_total,
      p.note ?? "",
    ]
      .map(escapeCsv)
      .join(","),
  );
  return [HEADER.join(","), ...rows].join("\n");
}
